// FLAGS: none
// Empty-state panel shown when the selected day has no bookable slots.
import { Box, Typography, Paper } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  paperRoot: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  box: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    textAlign: "center",
    [theme.breakpoints.down("lg")]: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
    },
  },
  typography: {
    opacity: 1,
  },
}));

const NoAvailableTimeSlots = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  return (
    <Paper className={classes.paperRoot}>
      <Box className={classes.box} data-cy="no-available-time-slots-message">
        <Typography className={classes.typography} variant="subtitle2">
          {t("Booking.TimeSlot.NoAvailableSlots.Day")}
        </Typography>
        <Typography className={classes.typography} variant="subtitle2">
          {t("Booking.TimeSlot.ChooseAnotherDay")}
        </Typography>
      </Box>
    </Paper>
  );
};

export default NoAvailableTimeSlots;
